/** Minimal JWT helpers — decode the payload to read claims like exp / tenant_id. */

export function decodeJwt(token: string): Record<string, unknown> | null {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(json) as Record<string, unknown>;
  } catch {
    return null;
  }
}

/** Token expiry as epoch milliseconds, or null if absent/unparseable. */
export function getJwtExpiryMs(token: string): number | null {
  const claims = decodeJwt(token);
  return typeof claims?.exp === 'number' ? claims.exp * 1000 : null;
}
